import React, { useState } from 'react';
import "../Css/LoginPage.css"

import { Link } from 'react-router-dom';
import TopHeader from '../Header/TopHeader';
import Navbar from '../Header/Navbar';


const Signup = () => {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('https://api.compliancekare.com/api/signup', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                // Signup successful, you can redirect or show a success message
                console.log('Signup successful');
            } else {
                // Signup failed, handle errors here
                console.error('Signup failed');
            }
        } catch (error) {
            // Handle network errors or other exceptions
            console.error('Error:', error);
        }
    };

    return (
        <>
        <TopHeader/>
        <Navbar/>

            <div className="wrapper ">
                <div className="container1 p-4">
                    <div className="col-left">
                        <div className="login-text" style={{ marginLeft: '-2rem' }}>
                            <h2>Compliancekare</h2>
                            <p style={{ fontSize: '20px', fontFamily: 'poppins',textAlign:"justify" }}>
                                Join our 1M+ customers who eFile with us. Easiest Way of e-filing
                                your Income Tax Return in India <br /> Best income tax efiling
                                website in India
                            </p>
                            <div style={{ display: 'flex' }}>
                                <div>
                                    <a className="btn" href="">
                                        Google
                                    </a>
                                </div>
                                &nbsp; &nbsp;
                                <div>
                                    <a className="btn" href="">
                                        Facebook
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-right">
                        <div className="login-form">
                            <h2>SignUp</h2>
                            <form onSubmit={handleSubmit}>
                                <p>
                                    <input
                                        type="text"
                                        name="username"
                                        value={formData.username}
                                        placeholder="Username"
                                        required
                                        onChange={handleInputChange}
                                    />
                                </p>
                                <p>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        placeholder="Email Address"
                                        required
                                        onChange={handleInputChange}
                                    />
                                </p>
                                <p>
                                    <input
                                        type="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        placeholder="Password"
                                        required
                                    />
                                </p>
                                <br /> <br />
                                <div>
                                    <p>
                                        <input className="btn" type="submit" value="Signup" />
                                    </p>
                                </div>
                                <p>
                                    Already have an account?{' '}
                                    <Link to="/login">
                                        <a href="#">Log In</a>
                                    </Link>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
                <br />
            </div>
        </>
    );
};

export default Signup;
